import { Box } from '@mui/material'

import { BudgetPreviewsStatus } from '@components/shared/BudgetPreviewsStatus'
import { currencyMask } from '@utils/masks/currencyMask'
import { previewHistoryColumn } from '@components/shared/PreviewHistoryDrawer'
import { emotionTheme } from '@styles/theme'
import { formattedIsoToPtBrDateTime } from '@utils/dates/formattedIsoToPtBrDateTime'
import { TrendingDown } from '@assets/svgs/TrendingDown'
import { TrendingUp } from '@assets/svgs/TrendingUp'

import type { ColumnDefProps } from '@components/shared/Table/types'
import type { BigNumbersDepreciationPreviewProps } from '../context/types'

interface ParseBudgetPreviewsGridProps {
  data: BigNumbersDepreciationPreviewProps[]
  onViewHistory: (weekNumber: number) => void
}

export const parseBudgetPreviewsGrid = ({ data, onViewHistory }: ParseBudgetPreviewsGridProps) => {
  if (!data) return []

  const parsedData: ColumnDefProps[][] = data.map((item) => [
    {
      id: 'previews',
      columnName: 'Prévias',
      align: 'center',
      minWidth: '7rem',
      value: item.previewNumber ? `${item.previewNumber}ª semana` : '-'
    },
    {
      id: 'previewAmount',
      columnName: 'Total Depreciação (R$)',
      align: 'center',
      currency: true,
      value: item.previewAmount || 0
    },
    {
      id: 'deviationAmount',
      columnName: 'Desvio (R$)',
      align: 'center',
      maxWidth: '7rem',
      value: (
        <>
          {item.deviationAmount === 0 ? (
            <>{currencyMask(item.deviationAmount.toFixed(2))}</>
          ) : !!item.deviationAmount ? (
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '4px',
                color: item.deviationAmount <= 0 ? emotionTheme.colors.error.color : emotionTheme.colors.success.color
              }}
            >
              {item.deviationAmount <= 0 ? <TrendingDown size="small" /> : <TrendingUp size="small" />}
              {currencyMask(item.deviationAmount?.toFixed(2))}
            </Box>
          ) : (
            '-'
          )}
        </>
      )
    },
    {
      id: 'detourPercentage',
      columnName: 'Desvio (%)',
      align: 'center',
      value: (
        <>
          {item.deviationPercentage === 0 ? (
            <>0,00%</>
          ) : (
            <>
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: '4px',
                  color:
                    item.deviationPercentage <= 0 ? emotionTheme.colors.error.color : emotionTheme.colors.success.color
                }}
              >
                {item.deviationPercentage <= 0 ? <TrendingDown size="small" /> : <TrendingUp size="small" />}
                {item.deviationPercentage ? `${item.deviationPercentage.toFixed(2)}%`.replace('.', ',') : '0,00%'}
              </Box>
            </>
          )}
        </>
      )
    },
    {
      id: 'lastUpdate',
      columnName: 'Atualização',
      align: 'center',
      minWidth: '11rem',
      value: item.updatedAt ? formattedIsoToPtBrDateTime(item.updatedAt) : '-'
    },
    {
      id: 'status',
      columnName: 'Status da Prévia',
      align: 'center',
      minWidth: '10rem',
      maxWidth: '14.5rem',
      value: <BudgetPreviewsStatus status={item.previewStatus} />
    },
    previewHistoryColumn(() => onViewHistory(item.previewNumber))
  ])

  return parsedData
}
